import React from "react";

const LinkedIn = () => (
  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.15385 8.50781H0.382812V23.8468H5.15385V8.50781Z" fill="white"/>
<path d="M12.8837 23.8455H8.125V8.51891H12.6983V10.6078H12.7601C13.221 9.82876 13.8831 9.18818 14.6769 8.75322C15.4707 8.31827 16.3669 8.10497 17.2715 8.13572C22.092 8.13572 22.9943 11.3123 22.9943 15.4406V23.8455H18.2851V16.4294C18.2851 14.6496 18.2851 12.3629 15.813 12.3629C13.341 12.3629 12.9455 14.2911 12.9455 16.2935L12.8837 23.8455Z" fill="white"/>
<path d="M2.75632 6.41108C4.2786 6.41108 5.51265 5.17704 5.51265 3.65476C5.51265 2.13249 4.2786 0.898438 2.75632 0.898438C1.23405 0.898438 0 2.13249 0 3.65476C0 5.17704 1.23405 6.41108 2.75632 6.41108Z" fill="white"/>
</svg>
);

export default LinkedIn;
